export default function getResource(label, vars = []) {
    const resources = {
        rewardBundlingTitle: 'Get three 100-point rewards for just 250 points.',
        rewardBundlingDescription: 'This perk will be auto-applied at checkout, one bundle per order, available for shipped orders only.',
        rewardBundlingTermsApply: 'Terms apply',
        rewardBundlingPromoApplied: 'Promo applied 🎉',
        rewardBundlingProgressAccessibility: 'Reward bundling progress'
    };

    return resources[label];
}
